import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=2fe385fb&"
import script from "./Tools.vue?vue&type=script&lang=js&"
export * from "./Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe385fb')) {
      api.createRecord('2fe385fb', component.options)
    } else {
      api.reload('2fe385fb', component.options)
    }
    module.hot.accept("./Tools.vue?vue&type=template&id=2fe385fb&", function () {
      api.rerender('2fe385fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Tools.vue"
export default component.exports